import BigNumber from 'bignumber.js';
export const formatDynamicCurrency = (value) => {
    if (value >= 100000) {
        // Large numbers: no decimals
        return value.toLocaleString('en-US', {
            maximumFractionDigits: 0,
        });
    }
    else if (value >= 1) {
        // Medium numbers: 2 decimals
        return value.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    else {
        // Small fractions: up to 4 decimals, no trailing zeros
        return value.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 4,
        });
    }
};
export const formatHoverNumber = (value) => {
    if (value === null || value === undefined || value === '') {
        return '0.00';
    }
    const num = new BigNumber(value);
    if (!num.isFinite()) {
        return '0.00';
    }
    if (num.isZero()) {
        return '0.00';
    }
    // Handle negative numbers - use absolute value for comparison, preserve sign in result
    const absNum = num.abs();
    if (absNum.lt(0.01)) {
        // Small values: 4 decimal places
        return num.decimalPlaces(4, BigNumber.ROUND_DOWN).toFixed(4);
    }
    // Regular values: 2 decimal places
    return num.decimalPlaces(2, BigNumber.ROUND_DOWN).toFixed(2);
};
